module.exports = "pegasus_template/assets/gray-large-twitter-old.png";